export const normalizeCategory = (item) => ({
  id: item.id,
  label: item.name || '',
  children: item.children || [],
});
